import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Icon, Row, Col, Select } from 'antd';
import { changeTimeFrame } from '../../action/okr_manage/okr';
import queryString from 'query-string';

const Option = Select.Option;

class OKRSider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeFrame: '',
      currentPath: ''
    }
  }

  componentWillMount() {

  }

  componentWillReceiveProps(props) {
    console.log('new props::', props);
    if (!this.state.timeFrame && props.timeFrames.length > 0) {
      this.changeTimeFrame(props.timeFrames[0].timeId.toString());
    }
    var path = window.location.hash.split('?')[0];
    path = path.replace('#', '');
    this.setState({ currentPath: path });
  }

  changeTimeFrame = (value) => {
    console.log('timeFrame:::', value);
    if (value) {
      this.setState({ timeFrame: value });
      this.props.changeTimeFrame(value);
    }
  }

  changeLink = (url) => {
    this.setState({ currentPath: url.pathname });
    window.location.href = '#' + url.pathname + url.search;
  }

  render() {
    const { query, user, timeFrames } = this.props;
    const userMenusArr = user.userMenus ? Object.keys(user.userMenus) : [];
    const siderList = [
      {
        id: 100,
        url: {
          pathname: '/okr_user',
          search: '?uid=' + user.uid,
        },
        moduleName: user.realName,
        icon: 'smile',
        api: '',
        subModules: []
      },
      {
        id: 99,
        url: {
          pathname: '/object_list',
          search: '',
        },
        moduleName: '目标',
        icon: 'edit',
        api: '',
        subModules: []
      },
      {
        id: 101,
        url: {
          pathname: '/okr_group',
          search: '',
        },
        moduleName: '部门',
        icon: 'global',
        api: '',
        subModules: []
      }];

    const optionTimeFrame = timeFrames.map((t) => {
      const tid = t["timeId"].toString();
      return (
        <Option searchValue={t["title"]} key={tid}
          value={tid}>{t["title"]}</Option>
      );
    });

    return (
      <div className="okr-sider-w">
        <div className="time-frame">
          <div><span className="icon-w"><Icon type="pause" /></span></div>
          <div>
            <Select
              style={{ width: 135 }}
              showSearch
              onChange={this.changeTimeFrame}
              value={this.state.timeFrame}
            >
              {optionTimeFrame}
            </Select>
          </div>
        </div>
        <ul className="menu-root">
          {
            siderList.map((rootItem) => {
              return (
                <li className={rootItem.url.pathname === this.state.currentPath ? 'menu-item active' : 'menu-item'} key={rootItem.id}>
                  <div className="menu-submenu-title" onClick={(e) => this.changeLink(rootItem.url)}>
                    <span className="icon-w"><Icon type={rootItem.icon} /></span>
                    {
                      rootItem.url ? <span onClick={(e) => this.changeLink(rootItem.url)} className="item-link">{rootItem.moduleName}</span> : rootItem.moduleName
                    }
                  </div>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}


const mapStateToProps = ({ query, user, page }) => {
  const { timeFrames } = page;
  return {
    query,
    user,
    timeFrames
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeTimeFrame: (t) => dispatch(changeTimeFrame(t))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OKRSider)


// WEBPACK FOOTER //
// ./src/components/okr_manage/okr_sider.js